<template>
  <div>
    <section class="service-title-wrap">
      <h4 class="service-title">{{ $t('menuService.vendorsRiders') }}</h4>
      <div class="service-title-sub">{{ $t('ceoAndRiders.headCopy') }}</div>
    </section>

    <section>
      <div class="service-item" data-service="ceo" :data-id="$t('ceoAndRiders.ceo.name')">
        <h5 :id="$t('ceoAndRiders.ceo.name')">{{ $t('ceoAndRiders.ceo.name') }}</h5>
        <div class="service-item-image">
          <picture>
            <source media="(min-width: 750px)" srcset="~@/static/image/service/pc/ceo@3x.jpg 3x">
            <source media="(max-width: 750px)" srcset="~@/static/image/service/m/ceo@3x.jpg 3x">
            <img src="~@/static/image/service/pc/ceo.jpg" :alt="$t('ceoAndRiders.ceo.name')">
          </picture>
        </div>
        <div class="service-item-title">
          <img
            src="~@/static/image/logo-family/logo_ceo.png"
            srcset="~@/static/image/logo-family/logo_ceo@2x.png 2x, ~@/static/image/logo-family/logo_ceo@3x.png 3x"
            :alt="$t('ceoAndRiders.ceo.name')"
          >
          <html-view tag="p" :value="$t('ceoAndRiders.ceo.title')" />
        </div>
        <div class="service-item-content">
          <html-view :value="$t('ceoAndRiders.ceo.content')" />
          <div class="btn-go-site"><a href="https://ceo.baemin.com/" class="btn-blank" target="_blank">{{ $t('ceoAndRiders.ceo.site') }}<icon-blank /></a></div>
        </div>
      </div>
      <div class="service-item" data-service="mart" :data-id="$t('ceoAndRiders.mart.name')">
        <h5 :id="$t('ceoAndRiders.mart.name')">{{ $t('ceoAndRiders.mart.name') }}</h5>
        <div class="service-item-image">
          <picture>
            <source media="(min-width: 750px)" srcset="~@/static/image/service/pc/mart@3x.jpg 3x">
            <source media="(max-width: 750px)" srcset="~@/static/image/service/m/mart@3x.jpg 3x">
            <img src="~@/static/image/service/pc/mart.jpg" :alt="$t('ceoAndRiders.mart.name')">
          </picture>
        </div>
        <div class="service-item-title">
          <img
            src="~@/static/image/logo-family/logo_mart.png"
            srcset="~@/static/image/logo-family/logo_mart@2x.png 2x, ~@/static/image/logo-family/logo_mart@3x.png 3x"
            :alt="$t('ceoAndRiders.mart.name')"
          >
          <html-view tag="p" :value="$t('ceoAndRiders.mart.title')" />
        </div>
        <div class="service-item-content">
          <html-view :value="$t('ceoAndRiders.mart.content')" />
          <div class="btn-go-site"><a href="https://mart.baemin.com/" class="btn-blank" target="_blank">{{ $t('ceoAndRiders.mart.site') }}<icon-blank /></a></div>
        </div>
      </div>
      <div class="service-item" data-service="kitchen" :data-id="$t('ceoAndRiders.kitchen.name')">
        <h5 :id="$t('ceoAndRiders.kitchen.name')">{{ $t('ceoAndRiders.kitchen.name') }}</h5>
        <div class="service-item-image">
          <picture>
            <source media="(min-width: 750px)" srcset="~@/static/image/service/pc/kitchen@3x.jpg 3x">
            <source media="(max-width: 750px)" srcset="~@/static/image/service/m/kitchen@3x.jpg 3x">
            <img src="~@/static/image/service/pc/kitchen.jpg" :alt="$t('ceoAndRiders.kitchen.name')">
          </picture>
        </div>
        <div class="service-item-title">
          <img
            src="~@/static/image/logo-family/logo_kitchen.png"
            srcset="~@/static/image/logo-family/logo_kitchen@2x.png 2x, ~@/static/image/logo-family/logo_kitchen@3x.png 3x"
            :alt="$t('ceoAndRiders.kitchen.name')"
          >
          <html-view tag="p" :value="$t('ceoAndRiders.kitchen.title')" />
        </div>
        <div class="service-item-content">
          <html-view :value="$t('ceoAndRiders.kitchen.content')" />
        </div>
      </div>
      <div class="service-item" data-service="connect" :data-id="$t('ceoAndRiders.connect.name')">
        <h5 :id="$t('ceoAndRiders.connect.name')">{{ $t('ceoAndRiders.connect.name') }}</h5>
        <div class="service-item-image">
          <picture>
            <source media="(min-width: 750px)" srcset="~@/static/image/service/pc/connect@3x.jpg 3x">
            <source media="(max-width: 750px)" srcset="~@/static/image/service/m/connect@3x.jpg 3x">
            <img src="~@/static/image/service/pc/connect.jpg" :alt="$t('ceoAndRiders.connect.name')">
          </picture>
        </div>
        <div class="service-item-title">
          <img
            src="~@/static/image/logo-family/logo_connect.png"
            srcset="~@/static/image/logo-family/logo_connect@2x.png 2x, ~@/static/image/logo-family/logo_connect@3x.png 3x"
            :alt="$t('ceoAndRiders.connect.name')"
          >
          <html-view tag="p" :value="$t('ceoAndRiders.connect.title')" />
        </div>
        <div class="service-item-content">
          <html-view :value="$t('ceoAndRiders.connect.content')" />
          <div class="btn-go-site"><a href="https://baeminconnect.onelink.me/k618/8ff5371c " class="btn-blank" target="_blank">{{ $t('ceoAndRiders.connect.site') }}<icon-blank /></a></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  components: {
    iconBlank: () => import('@/static/svg/blank.svg'),
  }
}
</script>
